<template>
  <div class="ReComment">
    <div class="userPic">
      <img :src="userIcon" alt="ava" class="avatar" />
    </div>
    <div class="commentCol">
      <p class="userName">{{userName}}</p>
      <!-- должно быть {{comment.userName}}-->
      <p class="comDate">{{comDate}}</p>
      <!--{{comment.comDate}}-->
      <p class="comText">{{comText}}</p>
      <!--{{comment.comText}}-->
      <div class="comReply">
        <div class="btnGroup">
          <button class="replyBtn mr-2">Ответить</button>
          <button class="replyBtn">Удалить</button><!--появляется только для своих комментов!-->
        </div>
        <a href="#">
          <ReLike :liketype="'like'" :counter="'200+'"></ReLike>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ReLike from "src/our_components/ReLike.vue";

export default {
  name: "ReComment",
  components: {
    ReLike
  },
  props: {
    counter: String,
    findId: {
      type: String,
      default: ""
    },   
    userIcon: {
      type: String,
      default: "/img/Default_userpic_M.svg"
    },
    userName: {
      type: String,
      default: "Имя Фамилия"
    },
    comDate: {
      type: String,
      default: "20 марта 2020 17:07"
    },
    comText: {
      type: String,
      default: "Текст сообщения Текст сообщения"
    }
  },
  data() {
    return {
      ver: 1
    };
  },
  computed: {},
  methods: {}
};
</script>

<style scoped>
.ReComment {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
}
.userPic {
  margin: 0 10px 0 0;
}
.userPic .avatar {
  width: 45px;
  height: 45px;
  object-fit: contain;
  margin-bottom: 0;
  background-color: transparent;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.commentCol {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  padding-right: 10px;
}
.comDate {
  opacity: 0.4;
}
.comReply {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

/*=== buttons===============================*/
.ReComment .btnGroup {
  display: flex;
}

.replyBtn {
  background-color: transparent;
  border: none;
  outline: none;
  color: #9e77f3;
  padding-left: 0;
}
.replyBtn:hover {
  color: #01b0e0;
}
</style>
